import { useLocation, useNavigate } from 'react-router-dom';
import GpanelContactsLabelsItem from './gpanel-contacts-labels/gpanel-contacts-labels-item';
import { GPanelContactsPagesConfig } from '../shared/pages-config';
import Sync from '@mui/icons-material/Sync';

export default function GpanelContactsSyncNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location.pathname.split('/');
  const path = pathSegments[2];

  const selected = path === GPanelContactsPagesConfig.ContactSyncs.link;

  return (
    <GpanelContactsLabelsItem
      label={GPanelContactsPagesConfig.ContactSyncs.name}
      icon={<Sync />}
      selected={selected}
      onClick={() =>
        navigate(`./${GPanelContactsPagesConfig.ContactSyncs.link}`)
      }
    />
  );
}
